const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditSuisse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 401.66,
    height: 51.5,
    viewBox: "0 0 401.66 51.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Credit Suisse logo - Brandlogos.net") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M347.58,374.24H321.67v5.82l.78-.07v-.07a4,4,0,0,1,3.62-2.48h5.75v30h5.68v-30h5.89c2,0,3.27,1.06,3.48,2.06v.14h.85l-.07-5.32h-.07Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.24,374.24h-.14V375l.07.07a3.82,3.82,0,0,1,1,3v29.39h5.54V392.34h2.48c2.2.14,3.05,1.56,4.12,3.41l.14.21.71,1.14c1.21,2,2.84,4.69,4.47,7.24a6.64,6.64,0,0,0,4.61,3.12,17.34,17.34,0,0,0,5.11-.14l1.21-.28.5-.14-1.7-.5a6.86,6.86,0,0,1-3.19-2.34,71.6,71.6,0,0,1-4.54-6.74l-2.13-3.41-.07-.07a8.84,8.84,0,0,0-3.19-3.05,8.56,8.56,0,0,0,6.18-8.09,7.48,7.48,0,0,0-2.34-5.47c-2.06-2-5.32-3-9.73-3Zm9.51,3c5.68.21,5.82,5,5.82,5.54,0,4.83-3.55,6.53-6.67,6.53l-2.2-.07v-12C225.34,377.22,226.4,377.15,227.75,377.22Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,374.24h-.14l.07.85H275c.5.21.92,1.42.92,2.41v29.89h9.51c6.25,0,11.5-1.92,15-5.61a16.18,16.18,0,0,0,1.28-21.15c-3.27-4.26-8.45-6.46-15.48-6.46Zm6.6,3.19h3a34.28,34.28,0,0,1,4.19.28c9.37,1.42,10.36,9.3,10.36,12.56,0,2.7-.5,6.6-2.84,9.58s-5.82,4.4-10.65,4.4c-1.14,0-2.56,0-4.12-.07C281.63,404,281.63,377.71,281.63,377.43Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,374.24H310.1V375l.07.07c.57.28,1,1.35,1,2.77v29.6h5.54V374.31Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.86,374.24H249.19l.07.78h.07a3.69,3.69,0,0,1,1.06,3v29.39H269l1.35-5.89-.78-.28-.21.35c-1.56,2.41-3.12,2.7-8.52,2.7a46.45,46.45,0,0,1-5-.21V390.49h9.44v-3h-9.44V377.22l7.67.07c1.7,0,3.62,1.63,3.76,2.63v.14h.78Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.53,374.24H417l.07.78h.07c.57.28,1,1.42,1,2.84v29.6h5.54V374.31Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.06,374.24h-18.6l.07.85h.07a3.51,3.51,0,0,1,1.06,2.91v29.39h18.6l1.35-5.89-.85-.28-.21.35c-1.56,2.41-3.12,2.7-8.45,2.7a46.43,46.43,0,0,1-5-.21V390.49h9.44v-3h-9.44V377.22l7.67.07c2.13,0,3.69,1.56,3.69,2.63v.14l.85-.07-.14-5.82Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.55,382.61c-.07,4.61,2.7,6.89,7.24,9.16l1.7.85c3.55,1.77,5.89,2.91,5.89,6.25a6.23,6.23,0,0,1-1.63,4.12,6,6,0,0,1-4.4,1.56c-5.32-.07-7.24-4.19-8-6.6l-.14-.43-1.14.21.28,7,.28.14a18.15,18.15,0,0,0,8.94,2.77,11.73,11.73,0,0,0,8.16-3.27,9.24,9.24,0,0,0,2.84-6.67c0-5.82-4-7.88-8.31-10.15l-.78-.43c-4.61-2.27-6.18-3.34-6.18-5.89,0-1.77,1.35-4.47,5-4.4a6.88,6.88,0,0,1,6.81,5l.14.5,1.14-.14-.43-6.1-.21-.14a13.38,13.38,0,0,0-7-1.92C437.88,373.88,432.62,376.93,432.55,382.61Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.58,382.61c-.07,4.61,2.7,6.89,7.24,9.16l1.7.85c3.55,1.77,5.89,2.91,5.89,6.25a6.23,6.23,0,0,1-1.63,4.12,6,6,0,0,1-4.4,1.56c-5.32-.07-7.24-4.19-8-6.6l-.14-.43-1.14.21.28,7,.28.14a18.15,18.15,0,0,0,8.95,2.77,11.73,11.73,0,0,0,8.16-3.27,9.24,9.24,0,0,0,2.84-6.67c0-5.82-4-7.88-8.31-10.15l-.78-.43c-4.61-2.27-6.18-3.34-6.18-5.89,0-1.77,1.35-4.47,5-4.4a6.88,6.88,0,0,1,6.81,5l.14.5,1.14-.14-.35-6-.21-.14a13.38,13.38,0,0,0-7-1.92C365,373.88,359.65,376.93,359.58,382.61Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.47,382.61c-.07,4.61,2.7,6.89,7.24,9.16l1.7.85c3.55,1.77,5.89,2.91,5.89,6.25a6.23,6.23,0,0,1-1.63,4.12,6,6,0,0,1-4.4,1.56c-5.32-.07-7.24-4.19-8-6.6l-.14-.43-1.14.21.28,7,.28.14a18.15,18.15,0,0,0,8.94,2.77,11.73,11.73,0,0,0,8.16-3.27,9.24,9.24,0,0,0,2.84-6.67c0-5.82-4-7.88-8.31-10.15l-.78-.43c-4.61-2.27-6.18-3.34-6.18-5.89a4.48,4.48,0,0,1,1.35-3.12,5.35,5.35,0,0,1,3.69-1.35,6.88,6.88,0,0,1,6.81,5l.14.43,1.14-.14-.35-6-.21-.14a13.38,13.38,0,0,0-7-1.92C462.87,373.88,457.54,376.93,457.47,382.61Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.69,374.24h-4.4l.07.78h.07c.21.14.92.64.92,2.7v18.81c0,3.62-1.35,8-7.74,8-6,0-7.31-3.62-7.31-9V374.16h-7l.07.71h.07a3.25,3.25,0,0,1,1.21,2.91v17.68c0,11,7.24,12.21,12.71,12.21,2.7,0,11.36-.78,11.36-11.15V374.09Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.78,379l.07.07-.07-.07a17.72,17.72,0,0,0-4.61,11.86,16.68,16.68,0,0,0,5.4,12.49A18.31,18.31,0,0,0,201.06,408a23.28,23.28,0,0,0,12.07-3.34l.21-.14.57-6.89-.92-.07-.14.28c-3.48,7.45-8.87,6.39-10.93,6.39-9.16,0-12.28-6.74-12.28-14.06,0-7,3.12-13.06,12.35-13.06,2.84,0,8-.07,10.65,6.32l.14.35.85-.28-.57-7.17-.21-.07a27.27,27.27,0,0,0-11.29-2.77A18,18,0,0,0,187.78,379Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.36,396.67c-6.18-1-12.85-1.56-17.75-.71a.4.4,0,0,1-.5-.43,73,73,0,0,0-1.35-14.13c0-.14-.07-.21-.21-.28a271.81,271.81,0,0,0-36.63-21.65.44.44,0,0,0-.5.71c17.39,16,23.5,43.16,24.28,46.78a.53.53,0,0,0,.5.35c19.52-3.76,39.11.92,44.58,2.41a.43.43,0,0,0,.43-.71c-4-4.33-8.31-8.38-12.64-12.21C568.57,396.74,568.5,396.67,568.36,396.67Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.76,399.44c-15.69-21-38-36.49-45-41.1-.43-.28-.85.21-.57.64A54,54,0,0,1,548.7,381a.37.37,0,0,0,.14.28c6.46,4.54,13.06,9.65,19.59,15.26a.26.26,0,0,0,.21.07c6.81,1.14,13.06,2.7,15.62,3.41A.42.42,0,0,0,584.76,399.44Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.58,374.24H321.67v5.82l.78-.07v-.07a4,4,0,0,1,3.62-2.48h5.75v30h5.68v-30h5.89c2,0,3.27,1.06,3.48,2.06v.14h.85l-.07-5.32h-.07Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.24,374.24h-.14V375l.07.07a3.82,3.82,0,0,1,1,3v29.39h5.54V392.34h2.48c2.2.14,3.05,1.56,4.12,3.41l.14.21.71,1.14c1.21,2,2.84,4.69,4.47,7.24a6.64,6.64,0,0,0,4.61,3.12,17.34,17.34,0,0,0,5.11-.14l1.21-.28.5-.14-1.7-.5a6.86,6.86,0,0,1-3.19-2.34,71.6,71.6,0,0,1-4.54-6.74l-2.13-3.41-.07-.07a8.84,8.84,0,0,0-3.19-3.05,8.56,8.56,0,0,0,6.18-8.09,7.48,7.48,0,0,0-2.34-5.47c-2.06-2-5.32-3-9.73-3Zm9.51,3c5.68.21,5.82,5,5.82,5.54,0,4.83-3.55,6.53-6.67,6.53l-2.2-.07v-12C225.34,377.22,226.4,377.15,227.75,377.22Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,374.24h-.14l.07.85H275c.5.21.92,1.42.92,2.41v29.89h9.51c6.25,0,11.5-1.92,15-5.61a16.18,16.18,0,0,0,1.28-21.15c-3.27-4.26-8.45-6.46-15.48-6.46Zm6.6,3.19h3a34.28,34.28,0,0,1,4.19.28c9.37,1.42,10.36,9.3,10.36,12.56,0,2.7-.5,6.6-2.84,9.58s-5.82,4.4-10.65,4.4c-1.14,0-2.56,0-4.12-.07C281.63,404,281.63,377.71,281.63,377.43Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,374.24H310.1V375l.07.07c.57.28,1,1.35,1,2.77v29.6h5.54V374.31Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.86,374.24H249.19l.07.78h.07a3.69,3.69,0,0,1,1.06,3v29.39H269l1.35-5.89-.78-.28-.21.35c-1.56,2.41-3.12,2.7-8.52,2.7a46.45,46.45,0,0,1-5-.21V390.49h9.44v-3h-9.44V377.22l7.67.07c1.7,0,3.62,1.63,3.76,2.63v.14h.78Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.53,374.24H417l.07.78h.07c.57.28,1,1.42,1,2.84v29.6h5.54V374.31Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.06,374.24h-18.6l.07.85h.07a3.51,3.51,0,0,1,1.06,2.91v29.39h18.6l1.35-5.89-.85-.28-.21.35c-1.56,2.41-3.12,2.7-8.45,2.7a46.43,46.43,0,0,1-5-.21V390.49h9.44v-3h-9.44V377.22l7.67.07c2.13,0,3.69,1.56,3.69,2.63v.14l.85-.07-.14-5.82Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.55,382.61c-.07,4.61,2.7,6.89,7.24,9.16l1.7.85c3.55,1.77,5.89,2.91,5.89,6.25a6.23,6.23,0,0,1-1.63,4.12,6,6,0,0,1-4.4,1.56c-5.32-.07-7.24-4.19-8-6.6l-.14-.43-1.14.21.28,7,.28.14a18.15,18.15,0,0,0,8.94,2.77,11.73,11.73,0,0,0,8.16-3.27,9.24,9.24,0,0,0,2.84-6.67c0-5.82-4-7.88-8.31-10.15l-.78-.43c-4.61-2.27-6.18-3.34-6.18-5.89,0-1.77,1.35-4.47,5-4.4a6.88,6.88,0,0,1,6.81,5l.14.5,1.14-.14-.43-6.1-.21-.14a13.38,13.38,0,0,0-7-1.92C437.88,373.88,432.62,376.93,432.55,382.61Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.58,382.61c-.07,4.61,2.7,6.89,7.24,9.16l1.7.85c3.55,1.77,5.89,2.91,5.89,6.25a6.23,6.23,0,0,1-1.63,4.12,6,6,0,0,1-4.4,1.56c-5.32-.07-7.24-4.19-8-6.6l-.14-.43-1.14.21.28,7,.28.14a18.15,18.15,0,0,0,8.95,2.77,11.73,11.73,0,0,0,8.16-3.27,9.24,9.24,0,0,0,2.84-6.67c0-5.82-4-7.88-8.31-10.15l-.78-.43c-4.61-2.27-6.18-3.34-6.18-5.89,0-1.77,1.35-4.47,5-4.4a6.88,6.88,0,0,1,6.81,5l.14.5,1.14-.14-.35-6-.21-.14a13.38,13.38,0,0,0-7-1.92C365,373.88,359.65,376.93,359.58,382.61Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.47,382.61c-.07,4.61,2.7,6.89,7.24,9.16l1.7.85c3.55,1.77,5.89,2.91,5.89,6.25a6.23,6.23,0,0,1-1.63,4.12,6,6,0,0,1-4.4,1.56c-5.32-.07-7.24-4.19-8-6.6l-.14-.43-1.14.21.28,7,.28.14a18.15,18.15,0,0,0,8.94,2.77,11.73,11.73,0,0,0,8.16-3.27,9.24,9.24,0,0,0,2.84-6.67c0-5.82-4-7.88-8.31-10.15l-.78-.43c-4.61-2.27-6.18-3.34-6.18-5.89a4.48,4.48,0,0,1,1.35-3.12,5.35,5.35,0,0,1,3.69-1.35,6.88,6.88,0,0,1,6.81,5l.14.43,1.14-.14-.35-6-.21-.14a13.38,13.38,0,0,0-7-1.92C462.87,373.88,457.54,376.93,457.47,382.61Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.69,374.24h-4.4l.07.78h.07c.21.14.92.64.92,2.7v18.81c0,3.62-1.35,8-7.74,8-6,0-7.31-3.62-7.31-9V374.16h-7l.07.71h.07a3.25,3.25,0,0,1,1.21,2.91v17.68c0,11,7.24,12.21,12.71,12.21,2.7,0,11.36-.78,11.36-11.15V374.09Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.78,379l.07.07-.07-.07a17.72,17.72,0,0,0-4.61,11.86,16.68,16.68,0,0,0,5.4,12.49A18.31,18.31,0,0,0,201.06,408a23.28,23.28,0,0,0,12.07-3.34l.21-.14.57-6.89-.92-.07-.14.28c-3.48,7.45-8.87,6.39-10.93,6.39-9.16,0-12.28-6.74-12.28-14.06,0-7,3.12-13.06,12.35-13.06,2.84,0,8-.07,10.65,6.32l.14.35.85-.28-.57-7.17-.21-.07a27.27,27.27,0,0,0-11.29-2.77A18,18,0,0,0,187.78,379Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.36,396.67c-6.18-1-12.85-1.56-17.75-.71a.4.4,0,0,1-.5-.43,73,73,0,0,0-1.35-14.13c0-.14-.07-.21-.21-.28a271.81,271.81,0,0,0-36.63-21.65.44.44,0,0,0-.5.71c17.39,16,23.5,43.16,24.28,46.78a.53.53,0,0,0,.5.35c19.52-3.76,39.11.92,44.58,2.41a.43.43,0,0,0,.43-.71c-4-4.33-8.31-8.38-12.64-12.21C568.57,396.74,568.5,396.67,568.36,396.67Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.76,399.44c-15.69-21-38-36.49-45-41.1-.43-.28-.85.21-.57.64A54,54,0,0,1,548.7,381a.37.37,0,0,0,.14.28c6.46,4.54,13.06,9.65,19.59,15.26a.26.26,0,0,0,.21.07c6.81,1.14,13.06,2.7,15.62,3.41A.42.42,0,0,0,584.76,399.44Z",
    transform: "translate(-183.17 -358.25)",
    style: {
      fill: "#183964"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditSuisse);
export default __webpack_public_path__ + "static/media/credit-suisse.5a8c545806d3600feaf60d893a4380db.svg";
export { ForwardRef as ReactComponent };